import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { Popover as CorePopover } from "wix-ui-core/dist/es/src/components/popover";
import { buildChildrenObject } from "wix-ui-core/dist/es/src/utils";
import requestAnimationFramePolyfill from '../utils/request-animation-frame';
import PropTypes from 'prop-types';
import { st, classes } from './Popover.st.css';
import { FontUpgradeContext } from '../FontUpgrade/context';
import FontUpgrade from '../FontUpgrade';
import { ThemeProviderConsumerBackwardCompatible } from '../ThemeProvider/ThemeProviderConsumerBackwardCompatible';
export { placements } from './constants';
/**
 *  This has been added in order to fix jsdom not having requestAnimation frame
 *  installed. Jest by default has this polyfilled, but mocha fails on it.
 *  Decided with Shlomi to get rid of this on next major version 7, where we will support
 *  only jest.
 */

if (process.env.NODE_ENV === 'test') {
  requestAnimationFramePolyfill.install();
}

var ANIMATION_ENTER = 150;
var ANIMATION_EXIT = 100;

var ContentElement = function ContentElement(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(FontUpgradeContext.Consumer, null, function (_ref2) {
    var active = _ref2.active;
    return /*#__PURE__*/React.createElement(FontUpgrade, {
      active: !!active
    }, /*#__PURE__*/React.createElement(CorePopover.Content, {
      children: children
    }));
  });
};

ContentElement.displayName = 'Popover.Content';

var Popover = /*#__PURE__*/function (_React$Component) {
  _inherits(Popover, _React$Component);

  var _super = _createSuper(Popover);

  function Popover() {
    _classCallCheck(this, Popover);

    return _super.apply(this, arguments);
  }

  _createClass(Popover, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dataHook = _this$props.dataHook,
          animate = _this$props.animate,
          theme = _this$props.theme,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, ["dataHook", "animate", "theme", "className"]);

      var timeout = animate ? {
        enter: ANIMATION_ENTER,
        exit: ANIMATION_EXIT
      } : undefined;
      return /*#__PURE__*/React.createElement(ThemeProviderConsumerBackwardCompatible, null, function (_ref3) {
        var themeClassName = _ref3.className;
        return /*#__PURE__*/React.createElement(CorePopover, _extends({
          disableClickOutsideWhenClosed: true,
          timeout: timeout,
          "data-hook": dataHook
        }, rest, {
          className: st(classes.root, {
            theme: theme
          }, className, themeClassName)
        }));
      });
    }
  }]);

  return Popover;
}(React.Component);

_defineProperty(Popover, "displayName", 'Popover');

_defineProperty(Popover, "Element", CorePopover.Element);

_defineProperty(Popover, "Content", ContentElement);

_defineProperty(Popover, "propTypes", _objectSpread(_objectSpread({}, CorePopover.propTypes), {}, {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** Adds enter and exit animation */
  animate: PropTypes.bool,

  /** The theme of the popover */
  theme: PropTypes.oneOf(['dark', 'light']),
  children: function children(props, propName) {
    var childrenArr = React.Children.toArray(props[propName]);
    var childrenObj = buildChildrenObject(childrenArr, {
      Element: null,
      Content: null
    });

    if (!childrenObj.Element) {
      return new Error('Invalid children provided, <Popover.Element/> must be provided');
    }

    if (!childrenObj.Content) {
      return new Error('Invalid children provided, <Popover.Content/> must be provided');
    }

    return childrenArr.reduce(function (err, child) {
      if (!err && child.type.displayName !== 'Popover.Element' && child.type.displayName !== 'Popover.Content') {
        return new Error("Invalid children provided, unknown child <".concat(child.type.displayName || child.type, "/> supplied"));
      }

      return err;
    }, false);
  }
}));

_defineProperty(Popover, "defaultProps", {
  appendTo: 'parent',
  animate: false
});

export default Popover;